var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("article", { staticClass: "no-box" }, [
    _c("section", { staticClass: "he-ad flex" }, [
      _c("strong", { staticClass: "ml-20" }, [
        _vm._v(_vm._s(_vm.title) + _vm._s(_vm.$t("权限列表")))
      ]),
      _c(
        "div",
        { staticClass: "ac-btn" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "info" },
              on: { click: _setup.handleExpandClick }
            },
            [_vm._v(_vm._s(_vm.$t("全部展开")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "danger" },
              on: { click: _setup.handleClearClick }
            },
            [_vm._v(_vm._s(_vm.$t("清空选择")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: { click: _setup.handleAllClick }
            },
            [_vm._v(_vm._s(_vm.$t("全选")))]
          )
        ],
        1
      )
    ]),
    _setup.permissionsData.length
      ? _c(
          "section",
          { staticClass: "tr-ee" },
          _vm._l(_setup.permissionsData, function(i) {
            return _c(_setup.PermissionNode, {
              key: i.resourceId,
              attrs: {
                node: i,
                selectedPermissions: _setup.selectedPermissions,
                expandedNodes: _setup.expandedNodes
              },
              on: {
                emitTree: _setup.handleTreeClick,
                emitExpand: _setup.renderExpand
              }
            })
          }),
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }